import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
// import { text } from 'd3';
import { Data2Service } from 'src/app/services/data2.service';
import { Subscription } from 'rxjs';
import { SvgDefinitionsComponent } from 'src/app/pages/_components/svg-definitions/svg-definitions.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SVGSpriteComponent } from 'src/app/pages/_components/svg-sprite/svg-sprite.component';

@Component({
  selector: 'app-portfolio-allocation',
  templateUrl: './portfolio-allocation.component.html',
  styleUrls: ['./portfolio-allocation.component.scss'],
  imports:[SvgDefinitionsComponent,SVGSpriteComponent,CommonModule,RouterModule]
})
export class PortfolioAllocationComponent implements OnInit, OnDestroy,OnChanges {

  @Input() investmentSymbol = '';
  @Input() initData:any = null;
  @Output() errors: EventEmitter<any> = new EventEmitter<any>();
  subscriptions:Array<Subscription> = [];
  ifa_indexes:any = null;

  investment:any;
  data:any;
  bgColor="#f00";
  color="#fff";
  totalPercent=0;
  totalHoldings=0;
  avgMktCap=0;
  priceToBook=0;
  avgBkMkt=0;
  missing:any = [];
  ifa_indexes_ids = [533, 535, 536, 538, 539, 540, 541, 542, 553, 555, 556, 557, 561, 568, 566, 564, 573, 576, 578, 580, 586, 850, 885, 6970, 888, 884, 12670, 28925, 28928, 28930, 28934, 28935, 29624, 893, 13748, 13749, 1108, 29873]

  constructor(private data2Service:Data2Service) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initData'] && changes['initData'].currentValue) {
      console.log('PortfolioAllocation ngOnChanges initData present, initializing');
      // Always attempt to initialize when initData arrives. If the parent mutates the same array reference
      // change detection may not emit a different previousValue; forcing initialization here makes it robust.
      this.initData = JSON.parse(JSON.stringify(changes['initData'].currentValue));
  
      this.dataReady();
    }
      if (changes['investmentSymbol'] && changes['investmentSymbol'].currentValue) {
        //console.log('PortfolioAllocation ngOnChanges portfolio changed to', changes['portfolio'].currentValue);
        this.initData=null;
        
        this.ngOnInit()
      }
      //console.log('PortfolioAllocation ngOnChanges', changes);
  }

  ngOnInit(): void {   

    if(this.initData==null && this.investmentSymbol!=''){
      this.subscriptions.push(this.data2Service.portfolio_underlying_mutual_funds$(`${this.investmentSymbol}`).subscribe(resp=>{
            //console.log("portfolio_underlying_mutual_funds",resp);
            this.initData=resp.data;
            this.dataReady();
      }));

      this.subscriptions.push(this.data2Service.investment$(`?$filter=symbol eq '${this.investmentSymbol}'`).subscribe(resp=>{
        this.investment=resp[0];
        //console.log("this.investment",this.investment)
        this.color='#'+this.investment.textcolor.trim();
        this.bgColor = '#'+this.investment.color.trim();      
      }))
    }

    

    this.subscriptions.push(this.data2Service.timeSeriesConstructionCurrentAllocation(this.ifa_indexes_ids.join(',')).subscribe(resp=>{
      this.ifa_indexes = resp;
      this.dataReady();
    }));
   

  
  }

  dataReady(){
    if(this.ifa_indexes!=null && this.initData!=null){
        console.log('PortfolioAllocation initializeData called, items:', Array.isArray(this.initData) ? this.initData.length : typeof this.initData);
    // reset accumulators before processing
    this.totalPercent = 0;
    this.totalHoldings = 0;
    this.avgMktCap = 0;
    this.priceToBook = 0;
    this.avgBkMkt = 0;

    if (!this.initData || !Array.isArray(this.initData)){
      console.warn('initializeData called with non-array', this.initData);
      return;
    }

    for(var i=0;i<this.initData.length;i++){
        this.totalPercent+=this.initData[i].percent || 0;
        this.totalHoldings+=this.initData[i].number_of_holdings;
        if(this.initData[i].weighted_avg_market_cap!=null){          
          this.avgMktCap+=this.initData[i].weighted_avg_market_cap*(this.initData[i].percent/100);
        }
        if(this.initData[i].weighted_book_to_market!=null){
          this.avgBkMkt+=this.initData[i].weighted_book_to_market*(this.initData[i].percent/100);
        } 
        if(this.initData[i].price_to_book!=null){
          this.priceToBook+=this.initData[i].price_to_book*(this.initData[i].percent/100);
        }      

        for(var j=0;j<this.ifa_indexes.length;j++){
          for(var k=0;k<this.ifa_indexes[j].allocations.length;k++){
            if(this.initData[i].symbol==this.ifa_indexes[j].allocations[k].symbol){
              this.initData[i].name = this.ifa_indexes[j].parent_name;
              this.initData[i].symbol = this.ifa_indexes[j].parent_symbol.toUpperCase();
              break;
            }
          }
        }

        // //We point to our Index and Backtested Disclosures for the actual underlying funds when it comes to our main portfolios:
        // //this.initData[i].name = this.initData[i].name.replace("Schwab S&P 500","IFA US Large Company Index");
        // //this.initData[i].symbol = this.initData[i].symbol.replace("SWPPX","LC");
        // this.initData[i].name = this.initData[i].name.replace("DFA US Equity ETF","IFA US Large Company Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFUS","LC");
        // //this.initData[i].name = this.initData[i].name.replace("DFA US Large Cap Value","IFA US Large Cap Value Index");
        // //this.initData[i].symbol = this.initData[i].symbol.replace("DFLVX","LV");
        // this.initData[i].name = this.initData[i].name.replace("DFA US Large Cap Value ETF","IFA US Large Cap Value Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFLV","LV");
        // //this.initData[i].name = this.initData[i].name.replace("DFA US Small Cap","IFA US Small Cap Index");
        // //this.initData[i].symbol = this.initData[i].symbol.replace("DFSTX","SC");
        // this.initData[i].name = this.initData[i].name.replace("DFA US Small Cap ETF","IFA US Small Cap Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFAS","SC");
        // //this.initData[i].name = this.initData[i].name.replace("DFA US Small Cap Value","IFA US Small Cap Value Index");
        // //this.initData[i].symbol = this.initData[i].symbol.replace("DFSVX","SV");
        // this.initData[i].name = this.initData[i].name.replace("Dimensional US Small Cap Value ETF","IFA US Small Cap Value Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFSV","SV");
        // //this.initData[i].name = this.initData[i].name.replace("DFA Global Real Estate Securities","IFA Global REIT Index");
        // //this.initData[i].symbol = this.initData[i].symbol.replace("DFGEX","RE");
        // this.initData[i].name = this.initData[i].name.replace("DFA Global Real Estate ETF","IFA Global REIT Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFGR","RE");
        // //this.initData[i].name = this.initData[i].name.replace("DFA International Value","IFA International Value Index");
        // //this.initData[i].symbol = this.initData[i].symbol.replace("DFIVX","IV");
        // this.initData[i].name = this.initData[i].name.replace("Dimensional International Value ETF","IFA International Value Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFIV","IV");
        // //this.initData[i].name = this.initData[i].name.replace("DFA International Small Company","IFA International Small Company Index");
        // //this.initData[i].symbol = this.initData[i].symbol.replace("DFISX","IS");
        // this.initData[i].name = this.initData[i].name.replace("DFA International Small Cap ETF","IFA International Small Company Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFIS","IS");
        // //this.initData[i].name = this.initData[i].name.replace("DFA International Small Cap Value","IFA International Small Cap Value Index");
        // //this.initData[i].symbol = this.initData[i].symbol.replace("DISVX","ISV");
        // this.initData[i].name = this.initData[i].name.replace("DFA International Small Cap Value ETF","IFA International Small Cap Value Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DISV","ISV");
        // //this.initData[i].name = this.initData[i].name.replace("DFA Emerging Markets","IFA Emerging Markets Index");
        // //this.initData[i].symbol = this.initData[i].symbol.replace("DFEMX","EM");
        // this.initData[i].name = this.initData[i].name.replace("DFA Emerging Core Equity Market ETF","IFA Emerging Markets Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFAE","EM");
        // //this.initData[i].name = this.initData[i].name.replace("DFA Emerging Markets Value","IFA Emerging Markets Value Index");
        // //this.initData[i].symbol = this.initData[i].symbol.replace("DFEVX","EV");
        // this.initData[i].name = this.initData[i].name.replace("DFA Emerging Markets Value ETF","IFA Emerging Markets Value Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFEV","EV");
        // // this.initData[i].name = this.initData[i].name.replace("DFA Emerging Markets Small Cap","IFA Emerging Markets Small Cap Index");
        // // this.initData[i].symbol = this.initData[i].symbol.replace("DEMSX","ES");
        // this.initData[i].name = this.initData[i].name.replace("Avantis Emerging Markets Small Cap Equity ETF","IFA Emerging Markets Small Cap Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("AVEE","ES");
        // this.initData[i].name = this.initData[i].name.replace("DFA One-Year Fixed Income","IFA One-Year Fixed Income Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFIHX","i1F");
        // this.initData[i].name = this.initData[i].name.replace("DFA Two-Year Global Fixed Income","IFA Two-Year Global Fixed Income Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFGFX","i2F");
        // this.initData[i].name = this.initData[i].name.replace("DFA Short Term Government","IFA Short Term Government Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFFGX","i3G");
        // this.initData[i].name = this.initData[i].name.replace("DFA Five-Year Global Fixed Income","IFA Five-Year Global Fixed Income Index");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFGBX","i5F");   //This one Mark and Peter are still deciding on. Should we add another EM2 index? or consolidate into the EM one? or change EM to be core 2?
        // this.initData[i].name = this.initData[i].name.replace("Dimensional Emerging Markets Cr Eq 2 ETF", "IFA Emerging Market Index TR");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFEM", "EM");
        // this.initData[i].name = this.initData[i].name.replace("Dimensional Em Mkts High Prof ETF", "IFA Emerging Market High Profitability Index TR");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DEHP", "EMH");
        // this.initData[i].name = this.initData[i].name.replace("Dimensional Core Fixed Income ETF", "IFA Core Fixed Income Index TR");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFCF", "CFI");
        // this.initData[i].name = this.initData[i].name.replace("Dimensional Global Credit ETF", "IFA Global Credit Index TR");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DGCB", "GC");
        // this.initData[i].name = this.initData[i].name.replace("Dimensional Global ex US Cor Fxd Inc ETF", "IFA Global Core Ex-US Fixed Income Index TR");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFGX", "GXF");
        // this.initData[i].name = this.initData[i].name.replace("Dimensional Short-Duration Fixed Inc ETF", "IFA Short Duration Fixed Income Index TR");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFSD", "SFI");

        // this.initData[i].name = this.initData[i].name.replace("Dimensional US Core Equity 2 ETF", "IFA US Core Equity 2 Index TR");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFAC", "UCE");

        //  this.initData[i].name = this.initData[i].name.replace("Dimensional US Core Equity 2 ETF", "IFA US Core Equity 2 Index TR");
        // this.initData[i].symbol = this.initData[i].symbol.replace("DFAC", "UCE");


        



        this.initData[i].lowersymbol = this.initData[i].symbol.toLowerCase();
      }
      const startsWithIFA = (x:any) => x.name.indexOf("IFA")==0;
      if(this.initData.every(startsWithIFA)){
        this.data=this.initData;
      }
      else{
        const missingIFAIndex = (x:any) => x.name.indexOf("IFA")!=0;
        this.missing = this.initData.filter(missingIFAIndex);
        console.log("missingIFAIndex", this.missing);
        console.log("error",this.initData)
        // Emit a structured error so parent can act upon it
        this.errors.emit({message:"There was a problem loading the data.", missing: this.missing});
        
        this.data=this.initData;
      }
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(x=>x.unsubscribe());
   }

  


}
